import React from 'react'
import { Typography } from '@smooth-ui/core-em'
import { Box } from 'UILibrary'
import { css } from 'react-emotion'
import logo from 'images/dv.png'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import starIcon from 'images/svg/star-icon.svg'
import { ROUTES_PATH, LOADING_STRING } from '../constants'
import { firstTimeFreeUser } from '../utils'
import CheckoutForm from '../features/payment/components/CheckoutForm'
import { userInfo } from 'actions'
import isempty from 'lodash.isempty'
import FlashMessage from 'components/FlashMessage'

const verifyAccountcontainer = css({
  width: '619px',
  margin: '0 auto -226px',
  textAlign: 'center',
  '@media (max-width: 640px)': {
    width: '95%',
  },
  '.verifyAccountlogo': {
    margin: '48px 0 44px',
    '@media (max-width: 640px)': {
      margin: '20px 0',
    },
  },
  '.verifyPaymentBox': {
    width: '100%',
    padding: '40px 60px',
    borderRadius: '4px',
    boxShadow: '0 2px 12px 2px rgba(0, 0, 0, 0.03)',
    border: 'solid 1px #ececec',
    backgroundColor: '#fff',
    marginBottom: '40px',
    textAlign: 'center',
    '@media (max-width: 767px)': {
      padding: '40px 0px',
    },
  },
  '.verifyPaymentheading': {
    display: 'block',
    fontSize: '32px',
    fontWeight: '500',
    letterSpacing: '-0.4px',
    textAlign: 'center',
    color: '#2d3447',
    padding: '0 15px',
  },
  '.verifyPaymenttext': {
    padding: '10px 15px',
    display: 'block',
    fontSize: '20px',
    fontWeight: '500',
    letterSpacing: '-0.3px',
    textAlign: 'center',
    color: '#6e7587',
  },
  '.verifyPaymentparagraph': {
    padding: '20px 15px 40px',
    display: 'block',
    fontSize: '16px',
    lineHeight: '1.31',
    textAlign: 'center',
    color: '#000',
    '@media (max-width: 767px)': {
      padding: '20px 15px 30px',
    },
  },
  '.verifyPaymentfooter': {
    display: 'flex',
    justifyContent: 'center',
  },
  '.verifyPaymentLaterbtn': {
    background: 'transparent',
    fontSize: '16px',
    width: 'auto !important',
    height: '42px !important',
    fontWeight: 'normal !important',
    padding: '0',
    color: '#00bcb5',
    '&:hover': {
      backgroundColor: 'transparent !important',
    },
    '@media (max-width: 380px)': {
      width: '158px !important',
      marginRight: '0px',
      fontSize: '14px',
    },
  },
  '.verifyPremiumbtn': {
    fontSize: '15px',
    fontWeight: '500',
    width: '158px !important',
    textTransform: 'uppercase',
    height: '42px !important',
    color: 'rgba(255, 255, 255, 0.8)',
    '&:hover': {
      background: 'transparent',
    },
  },
  '.pricingCards': {
    padding: '50px 46px',
    width: '100%',
    textAlign: 'left',
    boxShadow: '0 7px 23px 0 rgba(0, 0, 0, 0.04)',
    minHeight: '634px',
    marginBottom: '30px',
    display: 'flex',
    flexDirection: 'column',
    borderRadius: '0',
    '@media (max-width: 1240px)': {
      padding: '20px 16px',
      minHeight: 'inherit',
    },
    '@media (max-width: 991px)': {
      marginTop: '8px',
    },
    '@media (max-width: 767px)': {
      boxShadow: 'none',
      marginBottom: '0px',
      minHeight: 'inherit',
    },
  },
  '.freeCard': {
    borderTop: '#00bcb5 10px solid',
  },
  '.premiumCard': {
    borderTop: '#ffd200 10px solid',
  },
  '.pricingTitle': {
    fontSize: '52px',
    letterSpacing: '-0.7px',
    color: '#000000',
    padding: '0 0 30px',
    '@media (max-width: 1240px)': {
      fontSize: '40px',
    },
    '@media (max-width: 767px)': {
      fontSize: '30px',
    },
  },
  '.pricingContent': {
    minHeight: '105px',
    '@media (max-width: 991px)': {
      minHeight: 'inherit',
    },
  },
  '.pricingPara': {
    fontSize: '16px',
    lineHeight: 1.35,
    color: '#6e7587',
    padding: '0 5px 41px 0',
  },
  '.freeTitle': {
    color: '#00bcb5',
  },
  '.premiumTitle': {
    color: '#ffd200',
  },
  '.featuresText': {
    fontSize: '20px',
    fontWeight: 500,
    color: '#000000',
    textAlign: 'left',
    letterSpacing: '-0.3px',
    padding: '0 0 28px',
  },
  '.featureList': {
    listStyle: 'none',
    padding: '0',
    margin: '0',
    '& li': {
      display: 'flex',
      fontSize: '16px',
      color: '#000',
      marginBottom: '24px',
      textAlign: 'left',
      '&:before': {
        content: '""',
        display: 'block',
        width: '10px',
        borderRadius: '100%',
        margin: '4px 20px 0 0',
        height: '10px',
        backgroundColor: '#00bcb5',
      },
    },
  },
  '.premiumList': {
    listStyle: 'none',
    padding: '0 0 30px',
    margin: '0',
    '& li': {
      display: 'flex',
      alignItems: 'flex-start',
      fontSize: '16px',
      color: '#000',
      marginBottom: '24px',
      lineHeight: '24px',
      textAlign: 'left',
      '& img': {
        display: 'block',
        width: '22px',
        margin: '0 12px 0 0',
      },
    },
  },
  '.premiumPrices': {
    display: 'flex',
    alignItems: 'flex-start',
    color: '#6e7587',
    margin: '0 0 38px',
    position: 'relative',
    top: '-4px',
  },
  '.signText': {
    fontSize: '22px',
    fontWeight: '500',
    letterSpacing: '-0.3px',
  },
  '.amounText': {
    fontSize: '71px',
    fontWeight: '500',
    lineHeight: '60px',
    letterSpacing: '-1px',
    '@media (max-width: 1240px)': {
      fontSize: '42px',
      lineHeight: '36px',
    },
  },
  '.monthText': {
    fontSize: '22px',
    fontWeight: '500',
    alignSelf: 'flex-end',
    letterSpacing: '-0.3px',
  },
  '.pricingButton': {
    width: '100%',
    height: '64px',
    fontWeight: 700,
    textAlign: 'center',
    borderRadius: '6px',
    fontSize: '18px',
    letterSpacing: '0.6px',
    color: '#00bcb5',
    outline: '0',
    textTransform: 'uppercase',
    padding: '19px 0 19px',
    marginTop: 'auto',
    cursor: 'pointer',
    '@media (max-width: 767px)': {
      marginTop: '20px',
    },
  },
  '.continueBtn': {
    border: 'solid 1.5px #00bcb5',
    backgroundColor: '#fff',
  },
  '.subscribBtn': {
    border: 'solid 1.5px #00bcb5',
    backgroundColor: '#00bcb5',
    color: 'rgba(255, 255, 255, 0.8)',
  },
})

class WelcomePage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      showDetail: false,
      user: {},
      free: LOADING_STRING,
      done: LOADING_STRING,
    }
  }

  async componentWillMount() {
    try {
      const response = await this.props.userInfo(this.props.user.token)
      if (isempty(response.errors)) {
        this.setState({
          user: response.user,
          free: firstTimeFreeUser(response.user),
          done: true,
        })
        !this.state.free && this.props.history.push({ pathname: ROUTES_PATH.HOME })
      } else {
        this.props.showFlashMessage(true, response.errors)
      }
    } catch (error) {
      this.props.history.push({ pathname: ROUTES_PATH.HOME })
    }
  }

  toggleDetail = () => {
    const { showDetail } = this.state
    this.setState({
      showDetail: !showDetail,
    })
  }

  render() {
    const { showDetail, user, free, done } = this.state
    return (
      <div className={verifyAccountcontainer} hidden={done === LOADING_STRING}>
        <Link to="/">
          <img width="192px" alt="dealvestor_logo" src={logo} className="verifyAccountlogo" />
        </Link>
        <div className="verifyPaymentBox" hidden={!free}>
          <Box>
            <Typography className="verifyPaymentheading">Hi {user.firstName},</Typography>
          </Box>
          <Box>
            <Typography className="verifyPaymenttext">Welcome to DealVestors</Typography>
          </Box>
          <Box>
            <Typography className="verifyPaymentparagraph">
              Your account is now verified on DealVestors. Now you can continue with your payment to become a premium member.
            </Typography>
          </Box>
          <Box className="pricingCards premiumCard">
            <div className="pricingTitle premiumTitle">Premium</div>
            <div className="pricingContent">
              <div className="premiumPrices">
                <span className="signText">$</span>
                <span className="amounText">29.99</span>
                <span className="monthText">/month</span>
              </div>
              <div className="pricingPara">For serious real estate investors, a Premium Membership is an investment that can more than pay for itself.</div>
            </div>
            <div>
              <div className="featuresText">Features</div>
              <ul className="premiumList">
                <li>
                  <img alt="star" src={starIcon} />
                  You’ll be among the first to see our newest Premium Listings — putting you in a prime position to secure some of our most promising investment
                  properties.
                </li>
              </ul>
            </div>
            <button className="pricingButton subscribBtn" onClick={() => this.toggleDetail()}>
              Subscribe
            </button>
          </Box>
          <div className="verifyPaymentfooter">
            <Link className="verifyPaymentLaterbtn" to={ROUTES_PATH.HOME}>
              I’ll Decide Later
            </Link>
          </div>
        </div>
        <div className="verifyPaymentBox" hidden={free}>
          <Box>
            <Typography className="verifyPaymentparagraph">You are already a premium member.</Typography>
          </Box>
        </div>
        <CheckoutForm open={showDetail} onClose={() => this.toggleDetail()} history={this.props.history} />
        <FlashMessage />
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    user: state.user,
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      userInfo,
    },
    dispatch
  )
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(WelcomePage)



// WEBPACK FOOTER //
// ./src/containers/WelcomePage.js